// src/redux/currency/reducer.ts
import { SET_CURRENCY } from './actions';

interface CurrencyState {
  activeCurrency: string;
}

const initialState: CurrencyState = {
  activeCurrency: 'EUR',
};

const currencyReducer = (state = initialState, action: any): CurrencyState => {
  switch (action.type) {
    case SET_CURRENCY:
      return {
        ...state,
        activeCurrency: action.payload,
      };
    default:
      return state;
  }
};

export default currencyReducer;
